import React from 'react';

import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';

import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import MailIcon from '@material-ui/icons/Mail';

import { withStyles } from '@material-ui/core/styles';

import logoImage from '../../../Resources/Logo.PNG';

const styles = theme => ({
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
        textAlign: 'center',
    },
})

class FooterComponent extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <footer className={classes.footer}>
                <Grid container direction="row" spacing={3}>
                    <Grid container item direction="row" xs={12} sm={12} md={6} lg={6}>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'left', paddingLeft: '1rem' }}>
                            <img src={logoImage} alt="logo" style={{ width: '100px', height: '60px' }} />

                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'green', fontWeight: 'bold', textDecoration: 'underline' }}>
                                Jabatan Pengairan dan Salinan
                            </Typography>
                            <br />
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'green', fontWeight: 'bold', textDecoration: 'underline' }}>
                                Wilayah Persekutuan Kuala Lumpur
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'green' }}>
                                Jalan Sultan Salahuddin, 50626 Kuala Lumpur, Malaysia
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'green' }}>
                                No Tel: 03-26981711, Faks: 03-26932285
                            </Typography>
                        </Grid>

                        <br />
                        <br />

                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'green', fontWeight: 'bold', textDecoration: 'underline' }}>
                                External Link
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12}></Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12}></Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                            <Link href="http://prab.water.gov.my" style={{ color: "green", paddingLeft: '1rem' }}>
                                PRAB
                            </Link>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2}></Grid>

                    <Grid container item direction="row" xs={12} sm={12} md={4} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                                {'Copyright © '}
                                <Link color="inherit" href="https://www.surechem.com.my/products.php?type=brand">
                                    Surechem Sdn. Bhd.
                                </Link>{' '}
                                {new Date().getFullYear()}
                                {'.'}
                            </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={3}></Grid>

                        <Grid item xs={1} sm={1} md={1} lg={1}>
                            <FacebookIcon />
                        </Grid>
                        <Grid item xs={1} sm={1} md={1} lg={1}>
                            <InstagramIcon />
                        </Grid>
                        <Grid item xs={1} sm={1} md={1} lg={1}>
                            <TwitterIcon />
                        </Grid>
                        <Grid item xs={1} sm={1} md={1} lg={1}>
                            <LinkedInIcon />
                        </Grid>
                        <Grid item xs={1} sm={1} md={1} lg={1}>
                            <YouTubeIcon />
                        </Grid>
                        <Grid item xs={1} sm={1} md={1} lg={1}>
                            <MailIcon />
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={3}></Grid>

                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />

                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'right' }}>
                            {/* Developed by Nicholas Chin */}
                            &nbsp;
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'right' }}>
                            Build Version: Stable v2.3.18-03-2023
                        </Grid>
                    </Grid>
                </Grid>
            </footer>
        )
    }
}

export default withStyles(styles, { withTheme: true })(FooterComponent);